const postfix = {
	list: "List",
	text: "Text",
};

function filterListValues(uname, value) {
	console.log(uname, value);
	// document.querySelector(`[name="${uname}"]`).value = "";
	document.getElementById(`${uname}${postfix.list}`).querySelectorAll("li button").forEach((btn) => {
		const isShow = btn.textContent.toLowerCase().includes(value.toLowerCase());
		btn.parentElement.classList.toggle("d-none", !isShow);
	});
}

class InputList {
	constructor() {
		this.inputsValues = document.querySelectorAll(`[data-src-list]`);

		this.inputsValues.forEach(async (input) => {
			const listData = document.createElement("ul");
			const { data } = await fetch(input.dataset.srcList).then((i) => i.json());
			const listDataItems = data.map((item) => `<li class="mb-1"><button class="btn w-100 fw-light text-start btn-select-input rounded-0" data-value="${item.value}">${item.text}</button></li>`);
			const copyInput = input.cloneNode(false);

			if (copyInput.id) {
				copyInput.id = `${input.id}${postfix.text}`;
				copyInput.setAttribute("data-id", input.id);
			}
			copyInput.name = `${input.name}${postfix.text}`;
			copyInput.value = "";
			copyInput.setAttribute("data-name", input.name);
			input.type = "hidden";
			input.value = "";
			input.parentNode.insertBefore(copyInput, input);

			if (data) {
				listData.style.zIndex = 9999;
				listData.style.maxHeight = "200px";
				listData.style.overflowY = "auto";
				listData.id = `${input.name}${postfix.list}`;
				listData.classList.add("w-100", "bg-white", "position-absolute", "list-unstyled", "border", "shadow", "d-none");
				listData.innerHTML = listDataItems.join("\n");
				input.parentNode.appendChild(listData);

				copyInput.addEventListener("focusin", (e) => this.focusInput(e, true));
				copyInput.addEventListener("focusout", (e) => this.focusInput(e, false));
				copyInput.addEventListener("input", this.eventInput);
				copyInput.addEventListener("keyup", this.selectValuePressKey);
			}
		});
	}

	focusInput(e, isShowList) {
		const uname = e.target.dataset.name;

		if (e.relatedTarget && e.relatedTarget.classList.contains("btn-select-input")) {
			return this.selectValueBtn(uname, e.relatedTarget);
		}

		filterListValues(uname, e.target.value);
		document.getElementById(`${uname}${postfix.list}`).classList.toggle("d-none", !isShowList);
	}

	eventInput(e) {
		const { value } = e.target;
		const uname = e.target.dataset.name;

		filterListValues(uname, value);
	}

	selectValueBtn(uname, btn) {
		document.getElementById(`${uname}${postfix.list}`).classList.add("d-none");
		document.querySelector(`[name="${uname}${postfix.text}"]`).value = btn.textContent;
		document.querySelector(`[name="${uname}"]`).value = `${btn.textContent} --- ${btn.dataset.value}`;
		filterListValues(uname, btn.textContent);
	}

	selectValuePressKey(e) {
		const uname = e.target.dataset.name;

		document.querySelector(`[name="${uname}"]`).value = `${e.target.value} --- NULL`;
	}
}

export default InputList;
